import React from 'react';
import PropTypes from 'prop-types';

const TreeNode = ({ character, position, onClick }) => {
  if (!character || !position) return null;

  const handleClick = () => {
    if (onClick) onClick(character);
  };

  const displayName = character.name || 'Unnamed';

  return (
    <g
      transform={`translate(${position.x}, ${position.y})`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleClick();
      }}
      style={{ cursor: 'pointer' }}
    >
      <rect
        x={0}
        y={0}
        width={position.width}
        height={position.height}
        fill="rgba(30, 41, 59, 0.95)"
        stroke="rgba(255,255,255,0.20)"
        strokeWidth={1}
      />
      <text
        x={position.width / 2}
        y={position.height / 2}
        textAnchor="middle"
        dominantBaseline="central"
        fill="rgba(255,255,255,0.92)"
        fontSize={14}
        fontFamily="system-ui, -apple-system, Segoe UI, Roboto, sans-serif"
        style={{
          textRendering: 'geometricPrecision',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        }}
      >
        {displayName}
      </text>
    </g>
  );
};

TreeNode.propTypes = {
  character: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
  position: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  onClick: PropTypes.func,
};

TreeNode.defaultProps = {
  character: null,
  position: null,
  onClick: null,
};

export default TreeNode;
